window.browserCanUseArrowFunctions = function () {
	(() => {})();
	return true;
};
